import ConsolidateAffiliateModel from '@/models/ConsolidateAffiliate'
import CoreHelper from '@/helper/CoreHelper'
import wrapper from 'axios-cache-plugin'
import Vue from 'vue'

export default {
  data () {
    return {
      empty_data: 'Não existe',
      headers: [],
      column_filters: {},
      filters: {},
      items: [],
      pages: 1,
      current_page: 1,
      per_page: 400,
      total_visible_pages: 10,
      pagination: {},
      rowsPerPage: [25,50,100,{"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
    }
  },
  beforeMount: function () {
    this.updateData()
  },
  watch: {
    pages: function (val) {
      this.current_page = val
      this.updateData()
    }
  },
  filters: {
    currency: function (val) {
      return CoreHelper.toCurrency(val)
    },
    date: function (val) {
      return CoreHelper.toDate(val)
    }
  },
  methods: {
    updateData: function (name, filtered) {
      let req = this.getData(name, filtered)
      this.parseData(req)
    },
    clearData: function (name) {
      delete this.column_filters[name]
    },
    getData: function (name, filtered) {
      let startDate = this.$store.state.filters.startDate
      let endDate = this.$store.state.filters.endDate

      let endpoint = `${process.env.VUE_APP_API_DOMAIN}/overview/affiliates?`

      let params = {
        start: startDate,
        end: endDate,
        page: this.current_page,
        perPage: this.per_page
      }

      if (filtered !== undefined && filtered.length > 0) {
        this.column_filters[name] = ConsolidateAffiliateModel.parseColumnFilters(filtered)
      }

      let query = CoreHelper.toArrayQueryString({ ...params, ...this.column_filters })

      // Request cached.
      let cachedHttp = wrapper(Vue.prototype.$http, {
        maxCacheSize: 1000,
        ttl: 600000,
        excludeHeaders: true
      })
      cachedHttp.__addFilter(/affiliates/)

      return cachedHttp.get(`${endpoint}${query}`)
    },
    parseData: async function (req) {
      req.then((res) => {
        if (res.data.hasOwnProperty('items')) {
          let items = res.data.items
          let filters = res.data.filters
          this.pagination = res.data.pagination

          // Retrieve headers, rows and filters based at api result.
          if (items.length > 0) this.headers = ConsolidateAffiliateModel.parseHeadersFrom(items)
          this.items = ConsolidateAffiliateModel.parseRowsFrom(items)

          // Filters
          if (!this.filters.hasOwnProperty('affiliate_name')) this.filters.affiliate_name = filters.affiliate_name
        }
      }).catch(err => console.log(err))
    },
    customSort: function (items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "date") {
          if (!isDesc) {
            return CoreHelper.compareDates(a.date, b.date);
          } else {
            return CoreHelper.compareDates(b.date, a.date);
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      })

      return items
    }
  }
}
